import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {
      token: '',
      id: 0,
      isLogin: false,
      avatar: '',
      mobile: '',
      nickname: '',
      username: '',
      email: '',
      level: 0,
      user_id: 0,
      vip_show: '',
      vip_start: '',
      vip_start_text: '',
      vip_end: '',
      vip_end_text: ''
    },
    imageUrl: 'https://louyoushu.oss-cn-shenzhen.aliyuncs.com',
    lysConfig: {},
    configLoading: false,
    project: {
      id: 0,
      name: '',
      createtime: '',
      user_id: 0
    },
    rulesLoading: false,
    rules: [],
    nextRoute: ''
  },
  getters: {},
  mutations: {
    setUserInfo (state, payload) {
      for (const i in payload) {
        for (const j in state.user) {
          if (i === j) {
            state.user[j] = payload[i]
          }
        }
      }
      if (payload.isLogin) {
        state.user.isLogin = true
      }
      // 保存至缓存
      localStorage.setItem('lys_user', JSON.stringify(state.user))
    },
    isLogin (state) {
      return state.user.isLogin
    },
    getUserInfo (state) {
      console.log('getUserInfo------', state)
      return state.user
    },
    setLysConfig (state, payload) {
      state.lysConfig = payload
      state.configLoading = true
    },
    setRules (state, payload) {
      state.rules = payload
      state.rulesLoading = true
    },
    setProject (state, payload) {
      console.log('setProject------', payload)
      if (payload) {
        state.project = payload
        localStorage.setItem('lys_project', JSON.stringify(state.project))
      }
    },
    delProject (state, payload) {
      state.project = {
        id: 2,
        name: '',
        createtime: '',
        user_id: 0
      }
      localStorage.removeItem('lys_project')
    },
    getProject (state) {
      return state.project
    },
    getRules (state) {
      return state.rules
    },
    setNextRoute (state, payload) {
      // console.log('setMenuList------', payload)
      state.nextRoute = payload
    }
  },
  actions: {},
  modules: {}
})
